module.exports = __webpack_public_path__ + "img/tabbar5.e6f74c73.svg";